module.exports = {"data":{"site":{"siteMetadata":{"title":"Common Energy"}},"allMarkdownRemark":{"totalCount":2,"edges":[{"node":{"fields":{"slug":"/test/"},"frontmatter":{"title":"test"}}},{"node":{"fields":{"slug":"/blog/test/"},"frontmatter":{"title":"test"}}}]}},"pathContext":{"tag":"test"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-test.json
// module id = 439
// module chunks = 267260487189813